module.exports = __webpack_public_path__ + "img/people.ffc3a1d8.svg";